import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allPaymentRoutes } from '@/pages/payment/routes';

export const paymentRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.payment_method, action: PermissionAction.enum.view },
  },
  children: [
    ...allPaymentRoutes,
  ],
};
